<template>

  <div class="card card-default shadow">
    <!-- <div class="card-header">
      <div class="card-title">
        <button type="button" v-on:click="Print()" class="btn bg-custom btn-sm"> +print</button>
      </div>
    </div> -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Date From</label>
            <input type="date" class="form-control" v-model="dateFrom" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Date To</label>
            <input type="date" class="form-control" v-model="dateTo" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <br />
            <button class="btn btn-sm btn-primary" type="button" v-on:click="loadAttendance()">Load Attendance</button>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mt-2">
            <div class="table-responsive text-left">
              <table class="table table-bordered table-sm " id="tbl">
                <thead class="bg-custom">
                  <tr>
                    <th>Date</th>
                    <th>Status </th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>

                  <tr v-for="(result, ind) in attendance">
                    <td>{{result.Date}}</td>
                    <td v-if="result.Present" class="text-success text-bold text-center">Present</td>
                    <td v-else class="text-danger text-bold text-center">Absent</td>
                    <td>{{result.Remarks}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



<script>
  import axios from 'axios';
  export default {
    name: 'attendance',
    data() {
      return {
        attendance: [],
        courses: [],
        teacherID: 0,
        status: true,
        dateFrom: '',
        dateTo: ''
      }
    },
    created() {
      this.pageLoad();
    },
    updated() {
      $('#tbl').DataTable();
    },
    methods: {

      pageLoad() {

        var vm = this;
        axios.post('/api/PortalApi/pageLoadAttendance')
          .then(function (res) {
            vm.attendance = res.data.attendances;
            vm.dateFrom = res.data.dateFrom;
            vm.dateTo = res.data.dateTo;
          });
      },

      loadAttendance() {
        if (!this.dateFrom || !this.dateTo) {
          toastr.error("Date From and Date To is required")
          return;
        }

        var vm = this;
        axios.post('/api/PortalApi/loadAttendance?dateFrom=' + vm.dateFrom + '&dateTo=' + vm.dateTo)
          .then(function (res) {
            var table = $('#tbl').DataTable();
            table.destroy();
            vm.attendance = res.data.attendances;
          });
      },

      Print() {
        var url = new URLSearchParams(window.location.search);
        var id = url.get("teacherID")
        window.location.href = "/Portal/AttendancePrint?teacherID=" + id;
      },

    }
  }</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/school/attendance/attendance.vue